module.exports = __webpack_public_path__ + "img/presession_materials.4adcc365.png";